<template>
  <div id="news_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區公告列表
            <span
              class="introduction"
              @click="$toExternaLink('https://www.smartdaily.com.tw/post/')"
            >{{ $t("General.Instructions") }}</span>
          </div>
          <div class="tip">
            可檢視所有社區公告、刊登時間與狀態。
          </div>
        </div>
        <div class="right">
          <el-button
            icon="icon-setting"
            round
            @click="editConfig=true; openTypeSetting(); sortable=false"
          >
            設定
          </el-button>
        </div>
      </div>
      <filter-frame
        ref="filter"
        :save-filter="true"
        :filter-form="depositFilter"
        @search="search"
        @clear="clearSearch()"
      />
      <div class="title_bar center">
        <div class="left" />
        <div class="right">
          <el-button
            icon="icon-plus"
            round
            @click="$router.push({name:'newsEdit'})"
          >
            新增公告
          </el-button>
        </div>
      </div>
      <el-table
        class="newslist"
        :data="ListData"
        empty-text="目前無任何公告"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="Title"
          label="公告標題"
        >
          <template slot-scope="scope">
            <!-- 原本使用 span 搭配 router push 而非 link，現在改為 link -->
            <router-link
              :to="{
                name: 'newsDetail',
                params: {
                  id: scope.row.Id
                }
              }"
              class="news-title"
            >
              {{ scope.row.Title }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="公告類型"
          width="110"
        >
          <template slot-scope="scope">
            {{ scope.row.TypeName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="Start"
          label="公告起日"
          width="110"
        />
        <el-table-column
          prop="Due"
          label="公告訖日"
          width="110"
        />
        <el-table-column
          prop="Status"
          label="狀態"
          width="100"
        >
          <template slot-scope="scope">
            <div class="status-wrap">
              <span :class="reNewsStatus(scope.row).css" @click="showWarningAlert(scope.row)">{{ reNewsStatus(scope.row).text }}</span>
              <img
                v-if="scope.row.Status === ANN_STATUS.PENDING_ADJUSTMENT"
                src="@/assets/img/announcement/exclamation-mark-roundedline.svg"
                alt="exclamation-mark-roundedline"
                class="exclamation-mark-roundedline"
                @click="showWarningAlert(scope.row)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Popular"
          label="人氣"
          width="80"
        />
        <el-table-column
          prop="IsTop"
          label="置頂"
          width="80"
        >
          <template slot-scope="scope">
            <i
              v-if="scope.row.IsTop == 2"
              class="icon-check-mark"
              aria-hidden="true"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateDate"
          label="新增時間"
          width="150"
        />
        <el-table-column
          prop="date"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <!-- 原本使用 button 而非 link -->
            <!-- after -->
            <!-- 使用 link 而非 button，延用樣式直接添加原本的 class 即可 -->
            <!-- 若無處理、點擊自製的上一頁並非真的執行回到上一頁、而是新的路由、因此會無法回到原本的高度，若沿用以往處理方式則需要在點擊時紀錄高度、使按上一頁後能回到原本的高度 -->
            <!-- 下方連結為 link 搭配 click 的參考資訊 -->
            <!-- https://stackoverflow.com/questions/52229947/activate-method-on-router-link-click-in-vue -->
            <router-link
              v-if="scope.row.Status !== ANN_STATUS.DELETED && scope.row.Status !== ANN_STATUS.CREATING"
              :to="
                {
                  name: 'newsEdit',
                  query: {
                    id: scope.row.Id
                  }
                }
              "
              class="el-button el-button--default el-button--mini is-plain"
            >
              {{ scope.row.Status === ANN_STATUS.PENDING_ADJUSTMENT ? $t('News.Adjust') : $t('News.Modify') }}
            </router-link>
            <el-button
              v-else-if="scope.row.Status === ANN_STATUS.CREATING"
              size="mini"
              type="default"
              plain
              :disabled="true"
            >
              {{ $t('News.Modify') }}
            </el-button>
            <el-button
              v-if="scope.row.Status !== ANN_STATUS.DELETED"
              size="mini"
              type="danger"
              plain
              :disabled="scope.row.Status === ANN_STATUS.CREATING"
              @click="delNews(scope)"
            >
              刪除
            </el-button>
            <router-link
              v-if="scope.row.Status === ANN_STATUS.DELETED"
              :to="{
                name: 'newsDetail',
                params: {
                  id: scope.row.Id
                }
              }"
              class="el-button el-button--default el-button--mini is-plain"
            >
              {{ $t('News.View') }}
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
    <el-dialog
      id="setting"
      ref="setting"
      title="設定"
      :visible.sync="editConfig"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      :lock-scroll="true"
      center
      @close="goToTop()"
    >
      <div class="basicSetting">
        <div
          v-loading="modalLoading"
          class="block"
        >
          <div class="block_left">
            <h4>公告類型</h4>
          </div>
          <div class="block_right">
            <p class="description normalFont">
              新增類型
            </p>
            <el-row
              class="listHead"
              style="width: 100%"
              align="middle"
              type="flex"
            >
              <el-col class="typeInput">
                <el-input
                  v-model="newType"
                  class="normalInput disabledGrey"
                  :disabled="sortable"
                  style="width: 95%;height:30px;"
                  placeholder="最多15個字"
                  maxlength="15"
                  @keyup.enter="addType()"
                />
              </el-col>
              <el-col class="typeAdd">
                <el-button
                  size="mini"
                  :disabled="sortable"
                  plain
                  @click="addType()"
                >
                  新增
                </el-button>
              </el-col>
            </el-row>
            <el-row
              style="width: 100%;margin-top:10px"
              align="middle"
              type="flex"
            >
              <el-col>
                <p class="normalFont">
                  公告類型列表
                </p>
              </el-col>
              <el-col
                class="sortAdjust"
                align="right"
              >
                <el-switch
                  v-show="!sortable"
                  v-model="sortable"
                  active-color="#12B3A4"
                  inactive-color="#dcdfe6"
                  @change="saveOriginalList"
                />
                <p
                  v-show="!sortable"
                  class="arrange"
                >
                  調整排序
                </p>
                <el-button
                  v-show="sortable"
                  size="mini"
                  plain
                  @click="sortable=false;sortAdjust(false,false)"
                >
                  取消
                </el-button>
                <el-button
                  v-show="sortable"
                  size="mini"
                  plain
                  @click="sortable=false;sortAdjust(true,true)"
                >
                  儲存
                </el-button>
              </el-col>
            </el-row>
            <div class="postalL-list-content">
              <draggable
                v-model="TypeList"
                :options="{animation:150,handle:''}"
                :disabled="!sortable"
                class="draggable"
              >
                <transition-group>
                  <el-row
                    v-for="(type,type_index) in TypeList"
                    :key="type.Id"
                    class="normalList"
                    :class="sortable ? 'cursorMove' : '' "
                    :data="TypeList"
                    align="middle"
                    type="flex"
                  >
                    <el-col
                      v-if="sortable"
                      class="dragHandler"
                    >
                      <i
                        class="el-icon-d-caret"
                        aria-hidden="true"
                      />
                    </el-col>
                    <!-- <el-col class="indexNum">
                      <p> </p></el-col> -->
                    <el-col
                      class="typeName normalSize"
                      :class="editable?'noEffect':''"
                    >
                      <el-input
                        v-model="type.Name"
                        :class="!editList[type_index] ? 'noBorder':''"
                        :readonly="!editList[type_index]"
                        style="width: 95%;border:none;"
                        maxlength="15"
                        @keyup.enter="addType()"
                      >
                        {{ type.Name }}
                      </el-input>
                    </el-col>
                    <el-col
                      class="operationBtn alignRight"
                      align="right"
                    >
                      <!-- <el-button size="small" :class="!editList[type_index]? 'noFocusEffect' : ''" v-if="!editList[type_index]" @click="startEdit(type_index)" :disabled="sortable">編輯</el-button> -->
                      <!-- <el-button size="small" v-if="editList[type_index]" @click="finishEdit(type.Name,type_index,type.Id)" :disabled="sortable">儲存</el-button> -->
                      <el-button
                        v-if="!sortable"
                        class="alignRight"
                        align="right"
                        size="mini"
                        type="danger"
                        :disabled="sortable"
                        plain
                        @click="deleteType(type.Id,type_index)"
                      >
                        刪除
                      </el-button>
                    </el-col>
                  </el-row>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <!-- <el-button @click="handleCancelEdit()" round>取消</el-button> -->
        <el-button
          type="primary"
          round
          @click="handleSave()"
        >完成</el-button>
      </span>
    </el-dialog>
    <!-- 訊息對話框 -->
    <news-message-dialog
      :visible.sync="showWarningDialog"
      :title="$t('News.NewsPendingTitle')"
      :confirm-button-text="$t('News.NewsPendingButton')"
      @confirm="handleWarningDialogConfirm"
    />
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import filterFrame from '@/components/FilterFrame'
import draggable from 'vuedraggable'
import { ANN_STATUS } from '@/js/utils/announcementStatus'
import { setTimeout } from 'timers'
import NewsMessageDialog from './components/NewsMessageDialog.vue'

export default {
  components: {
    'filter-frame': filterFrame,
    draggable,
    TableLoading,
    NewsMessageDialog
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'newsEdit' || from.name === 'newsDetail') {
      next(vm => {
        if (vm.$store.state.news.edited) {
          vm.ListData = []
          vm.offset = 0
          vm.getList()
          vm.$store.commit('ifNewsEdit', false)
        } else {
          if (vm.$store.state.news.height != null) {
            vm.$nextTick(() => {
              document.documentElement.scrollTop = vm.$store.state.news.height
            })
          }
        }
      })
    }
    next(vm => {
      vm.showTopMessage()
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'newsDetail' && to.name !== 'newsEdit') {
      this.$store.commit('giveNewsHeight', null)
    } else {
      this.setNewsHeight()
    }
    next()
  },
  data () {
    return {
      ANN_STATUS,
      filter: {
        title: '',
        type: '',
        start: '',
        due: ''
      },
      defaultStatusFilter: [ANN_STATUS.UNPUBLISHED, ANN_STATUS.ANNOUNCING, ANN_STATUS.CREATING, ANN_STATUS.PENDING_ADJUSTMENT, ANN_STATUS.EXPIRED, ANN_STATUS.RESERVED], // 預設顯示已刪除以外的公告類型
      scrollEnd: false,
      loading: false,
      offset: 0,
      maxCount: 10,
      depositFilter: [
        {
          label: this.$t('News.Title'),
          name: 'title',
          type: 'input',
          rule: [
            {
              min: 0,
              max: 100,
              message: this.$t('News.TitleLimit'),
              trigger: 'blur'
            }
          ]
        },
        {
          label: this.$t('News.Type'),
          name: 'type',
          type: 'select',
          options: [],
          value: ''
        },
        {
          label: this.$t('News.Status'),
          name: 'status',
          type: 'select',
          isDisable: false,
          options: [],
          value: ''
        },
        {
          label: this.$t('News.DepositDate'),
          name: 'depositDate',
          type: 'date',
          pickerOptions: [
            { name: 'clearable', value: true }
          ]
        }
      ],
      ListData: [],
      deleteDialog: true,
      editConfig: false,
      TypeList: [],
      sortable: false,
      originalList: [],
      newType: '',
      modalLoading: false,
      editList: [],
      editable: false,
      clicked: false,
      isDisable: false,
      showWarningDialog: false,
      warningConfirmId: ''
    }
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler () {
        // 針對推播後同路由導頁做處理，強制刷新重查
        if (this.$route.name !== 'news' || !this.$route.fullPath.includes('preFilter')) return
        this.initPage()
      }
    }
  },
  mounted () {
    this.initPage()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    initPage () {
      this.clearInput()
      this.getStatusList().then(res => {
        if (this.$route.query.preFilter === 'true') {
          this.filter.status = ANN_STATUS.PENDING_ADJUSTMENT
          this.depositFilter[2].value = ANN_STATUS.PENDING_ADJUSTMENT
        }
        this.getList()
      })
      this.getTypeList().then(res => {
        this.giveFilterTypeList()
      })
      window.addEventListener('scroll', this.autoShow, true)
    },
    showTopMessage () {
      const message = sessionStorage.getItem('news_flash_message')
      if (!message) return

      sessionStorage.removeItem('news_flash_message')
      this.$message({
        message
      })
    },
    showWarningAlert (row) {
      if (row.Status !== ANN_STATUS.PENDING_ADJUSTMENT) return
      this.showWarningDialog = true
      this.warningConfirmId = row.Id
    },
    handleWarningDialogConfirm () {
      this.showWarningDialog = false
      this.$router.push({
        name: 'newsEdit',
        query: {
          id: this.warningConfirmId
        }
      })
    },
    // 查詢
    search (such_val) {
      this.filter = {
        title: such_val.title === undefined ? '' : such_val.title,
        type: such_val.type === undefined ? '' : such_val.type,
        status: such_val.status === undefined ? this.defaultStatusFilter : such_val.status,
        start: such_val.depositDate === undefined ? '' : such_val.depositDate[0],
        due: such_val.depositDate === undefined ? '' : such_val.depositDate[1]
      }
      this.ListData = []
      this.offset = 0
      this.scrollEnd = false
      window.scrollTo(0, 0)
      this.getList()
    },
    // 清除條件
    clearSearch () {
      this.clearInput()
      this.getList()
    },
    clearInput () {
      this.filter = {
        title: '',
        type: '',
        status: '',
        start: '',
        due: ''
      }
      this.depositFilter[2].value = ''
      this.$delete(this.$refs.filter.selectedValue, 'title')
      this.$delete(this.$refs.filter.selectedValue, 'type')
      this.$delete(this.$refs.filter.selectedValue, 'status')
      this.ListData = []
      this.offset = 0
      this.scrollEnd = false
      window.scrollTo(0, 0)
    },
    // 取得公告列表
    getList () {
      if (this.loading) { return }
      this.loading = true
      const Authorization = this.$getCookie('comLoginToken').replace(
        'token=',
        ''
      )
      const data = {
        offset: this.offset,
        maxCount: this.maxCount
      }

      // 把狀態給進去params
      Object.keys(this.filter).forEach(val => {
        if (this.filter[val] !== '') {
          data[val] = this.filter[val]
        }
      })

      if (!Object.hasOwn(data, 'status')) {
        data.status = this.defaultStatusFilter
      }

      return axios(`${process.env.VUE_APP_MAPI_URL}/Announcement/v3/List`, {
        method: 'GET',
        params: data,
        headers: {
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          Authorization
        }
      }).then(async (res) => {
        if (res.data.Data.Announcements.length !== 0) {
          await this.$sleep(1000)
          for (let i = 0; i < res.data.Data.Announcements.length; i++) {
            this.ListData.push(res.data.Data.Announcements[i])
          }
          if (res.data.Data.Announcements.length < 10) {
            this.scrollEnd = true
          }
        } else {
          this.scrollEnd = true
        }
        this.loading = false
        return true
      }).catch(err => {
        console.log(err)
        this.loading = false
        return false
      })
    },
    // 回傳狀態中文名稱
    reNewsStatus (obj) {
      const text = this.depositFilter[2].options.find(item => item.value === obj.Status)?.label || ''
      switch (obj.Status) {
      case ANN_STATUS.UNPUBLISHED:
        return { text, css: 'status-unpublished' }
      case ANN_STATUS.ANNOUNCING:
        return { text, css: 'status-announcing' }
      case ANN_STATUS.DELETED:
        return { text, css: 'status-deleted' }
      case ANN_STATUS.CREATING:
        return { text, css: 'status-creating' }
      case ANN_STATUS.PENDING_ADJUSTMENT:
        return { text, css: 'status-pending_adjustment' }
      case ANN_STATUS.EXPIRED:
        return { text, css: 'status-expired' }
      case ANN_STATUS.RESERVED:
        return { text, css: 'status-reserved' }
      default:
        return { text: '', css: '' }
      }
    },
    // 下拉到底自動載入
    autoShow () {
      // 視窗滾動條高度
      const ScrollTop = document.documentElement.scrollTop
      // 視窗可視範圍高度
      const ClientHeight = document.documentElement.clientHeight
      // 內容實際高度
      const ScrollHeight = document.documentElement.scrollHeight
      if (this.editConfig) return false
      if (
        ScrollTop + ClientHeight >= ScrollHeight - 20 &&
        !this.loading &&
        !this.modalLoading &&
        this.$router.currentRoute.name === 'news'
      ) {
        if (!this.scrollEnd) {
          this.offset += 10
          this.$handleScroll(this.getList)
        }
      }
    },
    // 刪除公告
    delNews (row_data) {
      const vobj = this
      const Authorization = this.$getCookie('comLoginToken').replace(
        'token=',
        ''
      )
      this.$confirm('公告刪除後將無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      })
        .then(() => {
          axios(`${process.env.VUE_APP_MAPI_URL}/Announcement/v3/Delete`, {
            method: 'PUT',
            data: { Id: row_data.row.Id },
            headers: {
              Authorization
            }
          })
            .then(res => {
              vobj.ListData.splice(row_data.$index, 1)
              vobj.$message({
                type: 'success',
                message: '刪除成功'
              })
            })
            .catch(err => {
              vobj.$message({
                type: 'info',
                message: err.response
              })
            })
        })
        .catch(() => {})
    },
    open (url) {
      window.open(url, '_blank')
    },
    openTypeSetting () {
      this.getTypeList()
      this.saveOriginalList()
    },
    handleCancelEdit () {
      // 社區基本設定 - 取消編輯
      // this.configData = _cloneDeep(this.configDataOri)
      this.editConfig = false
    },
    handleSave () {
      let same = true
      for (let i = 0; i < this.TypeList.length; i++) {
        if (this.TypeList.length === this.originalList.length) {
          if (this.TypeList[i].Id !== this.originalList[i].Id) {
            same = false
          }
        } else {
          same = false
        }
      }
      if (!same && !this.sortable) {
        this.sortAdjust(false, true)
        console.log('列表不一樣，進行順序更新')
        this.$refs.filter.onClear()
        this.giveFilterTypeList()
      } else {
        console.log('不用動')
      }
      this.newType = ''
      this.editConfig = false
    },
    addType () {
      if (!this.clicked) {
        this.clicked = true
      } else {
        return false
      }
      if (this.newType) {
        for (const item of this.TypeList) {
          if (this.newType === item.Name) {
            this.$message({
              message: '此類別已存在',
              type: 'warning'
            })
            setTimeout(() => {
              this.clicked = false
            }, 3000)
            return false
          }
        }
        this.putType(this.newType)
          .then(res => {
            this.TypeList.push({ Name: this.newType, Id: res.Data.Id })
            this.newType = ''
            setTimeout(() => {
              this.clicked = false
            }, 800)
            return res
          })
          .then(res => {
            this.sortAdjust(false, true)
          })
          .catch(error => {
            setTimeout(() => {
              this.clicked = false
            }, 800)
            console.log(error)
          })
      } else {
        this.$message({
          message: '請輸入類別名稱',
          type: 'warning'
        })
        setTimeout(() => {
          this.clicked = false
        }, 3000)
      }
    },
    putType (type, action, index) {
      this.$refs.filter.onClear()
      const KingnetAuth =
        'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
      return new Promise((resolve, reject) => {
        axios(
          `${process.env.VUE_APP_CORE_URL}/api/CustomType/AnnouncementCreate`,
          {
            method: 'PUT',
            data: {
              Name: type
            },
            headers: {
              KingnetAuth
            }
          }
        )
          .then(response => {
            if (
              response.data.Data.Id !== null && response.data.Data.Id !== undefined
            ) {
              this.$message({
                message: '新增類別成功',
                type: 'success'
              })
              resolve(response.data)
            } else if (
              response.data.Data.errors.Name[0] === '名稱不能包含空白'
            ) {
              this.$message.error(
                '新增類型失敗，類型名稱中不可有空格、特殊符號，請再試一次。'
              )
              reject(response)
            } else {
              this.$message.error('新增類別失敗')
              reject(response)
            }
          })
          .catch(err => {
            this.$message.error('新增類別失敗')
          })
      })
    },
    async getStatusList () {
      this.modalLoading = true
      this.editable = false
      const Authorization = this.$getCookie('comLoginToken').replace('token=', '')
      return new Promise((resolve, reject) => {
        axios(
          `${process.env.VUE_APP_MAPI_URL}/Announcement/v3/StatusList`,
          {
            method: 'GET',
            headers: {
              'content-type': 'application/json',
              'cache-control': 'no-cache',
              Authorization
            }
          }
        )
          .then(res => {
            this.modalLoading = false
            if (res.status === 200) {
              const statusSortOrder = [
                ANN_STATUS.UNPUBLISHED,
                ANN_STATUS.CREATING,
                ANN_STATUS.RESERVED,
                ANN_STATUS.ANNOUNCING,
                ANN_STATUS.EXPIRED,
                ANN_STATUS.DELETED,
                ANN_STATUS.PENDING_ADJUSTMENT
              ]
              const sortedStatus = Object.fromEntries(
                Object.entries(res.data.Data).sort(
                  ([, a], [, b]) => statusSortOrder.indexOf(a) - statusSortOrder.indexOf(b)
                )
              )
              this.depositFilter[2].options = []
              this.depositFilter[2].options.push({ label: `${this.$t('News.Select')}`, value: '' })
              this.depositFilter[2].options.push(...Object.entries(sortedStatus).map(([label, value]) => ({
                label,
                value
              })))
              resolve()
            } else {
              reject(new Error('取得公告狀態失敗'))
            }
          })
          .catch(err => {
            console.log(err.response)
          })
      })
    },
    getTypeList () {
      this.modalLoading = true
      this.editable = false
      const KingnetAuth =
        'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
      return new Promise((resolve, reject) => {
        axios(
          `${process.env.VUE_APP_CORE_URL}/api/CustomType/AnnouncementList`,
          {
            method: 'GET',
            // params: data,
            headers: {
              'content-type': 'application/json',
              'cache-control': 'no-cache',
              KingnetAuth
            }
          }
        )
          .then(res => {
            this.modalLoading = false
            if (res.status === 200) {
              this.TypeList = res.data.Data.List
              resolve(res.data.Data.List)
            } else {
              reject(new Error('取得公告類別失敗'))
            }
          })
          .catch(err => {
            console.log(err.response)
          })
      })
    },
    giveFilterTypeList () {
      this.depositFilter[1].options = []
      this.depositFilter[1].options.push({ label: '請選擇', value: '' })
      for (const item of this.TypeList) {
        const obj = {}
        obj.label = item.Name
        obj.value = item.Id
        this.depositFilter[1].options.push(obj)
      }
    },
    editDelete (id, index) {
      const KingnetAuth =
        'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
      const deleteList = []
      deleteList.push(id)
      axios(
        `${process.env.VUE_APP_CORE_URL}/api/CustomType/AnnouncementDisable`,
        {
          method: 'PUT',
          headers: {
            'content-type': 'application/json',
            'cache-control': 'no-cache',
            KingnetAuth
          },
          data: {
            Ids: deleteList
          }
        }
      )
        .then(response => {
          if (response.data.Status !== 1) {
            this.$message.error('編輯類別失敗')
          }
        })
        .catch(err => {
          this.$message.error('編輯類別失敗')
        })
    },
    deleteType (id, index) {
      if (this.isDisable === true) {
        return false
      }
      if (this.TypeList.length <= 1) {
        this.isDisable = true
        this.$message.error('公告類型須至少保留一個。')
        setTimeout(() => {
          this.isDisable = false
        }, 1000)
      } else {
        const KingnetAuth =
          'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
        const deleteList = []
        deleteList.push(id)
        this.$confirm('類型刪除後將無法復原，確認是否刪除？', '', {
          confirmButtonText: '確定',
          cancelButtonText: '取消'
        }).then(() => {
          this.$refs.filter.onClear()
          axios(
            `${
              process.env.VUE_APP_CORE_URL
            }/api/CustomType/AnnouncementDisable`,
            {
              method: 'PUT',
              headers: {
                KingnetAuth
              },
              data: {
                Ids: deleteList
              }
            }
          )
            .then(response => {
              if (response.data.Status === 1) {
                this.TypeList.splice(index, 1)
                this.editList.splice(index, 1)
                this.$message({
                  message: '刪除成功',
                  type: 'success'
                })
              } else {
                this.$message.error('刪除失敗')
              }
            })
            .catch(err => {
              console.log(err)
              this.$message.error('刪除失敗')
            })
        }).catch(e => {})
      }
    },
    sortAdjust (ifMsg, ifSort) {
      // ifMsg 是否顯示彈窗 ; state 0:重置排序 1:調整排序
      const KingnetAuth =
        'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
      if (ifSort && this.TypeList.length > 0) {
        this.TypeList.map((item, index) => {
          item.sort = index + 1
        })
        this.TypeList.sort((a, b) => {
          return a.sort - b.sort
        })
        return new Promise((resolve, reject) => {
          axios(
            `${
              process.env.VUE_APP_CORE_URL
            }/api/CustomType/AnnouncementChangeSort`,
            {
              method: 'PUT',
              headers: {
                KingnetAuth
              },
              data: {
                ChangeSortList: this.TypeList
              }
            }
          )
            .then(response => {
              if (ifMsg) {
                if (response.data.Status === 1) {
                  this.$message({
                    message: '修改排序成功',
                    type: 'success'
                  })
                  resolve(response.data)
                } else {
                  this.$message.error('修改排序失敗')
                  reject(new Error('修改排序失敗'))
                }
              } else {
                resolve(response.data)
              }
            })
            .catch(err => {
              this.$message.error('修改排序失敗')
            })
        })
      } else {
        this.TypeList = this.originalList
      }
    },
    saveOriginalList () {
      return new Promise((resolve, reject) => {
        this.originalList = _cloneDeep(this.TypeList)
      })
    },
    startEdit (index) {
      this.editList[index] = true
      this.editable = true
    },
    finishEdit (type, index, id) {
      this.modalLoading = true
      setTimeout(() => {
        if (type !== '') {
          this.editList[index] = false
          this.editable = false
          this.editDelete(id, index, 'edit')
          this.updateType(type, index).then(res => {
            this.sortAdjust(false, true).then(res => {
              setTimeout(() => {
                this.modalLoading = false
              }, 300)
            })
          })
        } else {
          this.$message({
            message: '請輸入類別名稱',
            type: 'warning'
          })
        }
      }, 100)
    },
    updateType (type, index) {
      const KingnetAuth =
        'Cookies ' + this.$getCookie('comLoginToken').replace('token=', '')
      return new Promise((resolve, reject) => {
        axios(
          `${process.env.VUE_APP_CORE_URL}/api/CustomType/AnnouncementCreate`,
          {
            method: 'PUT',
            data: {
              Name: type
            },
            headers: {
              KingnetAuth
            }
          }
        )
          .then(response => {
            if (response.data.Status === 1) {
              this.TypeList[index].Id = response.data.Data.Id
              this.$message({
                message: '編輯類別成功',
                type: 'success'
              })
              resolve(response.data)
            } else {
              this.$message.error('編輯類別失敗')
              reject(response)
            }
          })
          .catch(err => {
            this.$message.error('編輯類別失敗')
          })
      })
    },
    giveTypeName (typeNo, list) {
      let haveName = false
      for (const item of list) {
        if (item.Id === typeNo) {
          haveName = true
          return item.Name
        } else {
          haveName = false
        }
      }
      if (haveName === false) {
        return '類型已被刪除'
      }
    },
    goToTop () {
      document.getElementById('setting').scrollTop = 0
    },
    setNewsHeight () {
      this.$store.commit('giveNewsHeight', document.documentElement.scrollTop)
    }
  }
}
</script>

<style lang="sass" scoped>
#news_main
  text-align: center
  padding: 50px 0 10px
  height: 100%
  ::v-deep .el-dialog__wrapper
    overflow: hidden
  ::v-deep .el-dialog
    +basicDialog
    overflow: auto
    max-height: 80%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .introduction
        color: $mainColorDark
        font-size: 20px
        font-weight: initial
        margin: 0 10px
        text-decoration: underline
        cursor: pointer
        &:before
          content: '('
          color: #000
        &:after
          content: ')'
          color: #000
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 20px 0
    .newslist
      font-size: 15px
      .cell
        +NewsStatusTag
      .news-title
        cursor: pointer
        color: $mainColor
        text-decoration: underline
      ::v-deep .el-table
        +basicTable
        &__body a.el-button--default.is-plain
          color: #333

.basicSetting
  width: 100%
  .block
    display: flex
    flex-wrap: wrap
    &:not(:first-child)
      margin-top: 15px
    .block_left
      width: 20%
    .block_right
      display: flex
      flex-wrap: wrap
      width: 80%
      .description
        width: 100%
      .normalFont
        font-size: 15px
        color: #333
        margin-right: 20px
        line-height: 30px
      .normalFont  ::v-deep .el-input__inner
        height: 30px !important
        font-size: 15px !important
      .normalSize  ::v-deep .el-input__inner
        font-size: 15px !important
  .down
    border-top: none
.postalL-list-content
  color: #606266
  font-size: 15px
  width: 100%
  .el-row
    margin: 5px 0
    // padding: 12px 0
    border: solid 1px #ccc
    border-radius: 5px
    text-align: center
    background-color: rgba(255,255,255,1)
    &.listHead
      font-weight: bold
      color: #909399
    &.sortable-ghost
      opacity: 0
    &.sortable-drag
    .dragHandler
      flex-basis: 50px
      text-align: right
      i
        font-size: 15px
        color: #fff
        background-color: #41A07D
        border-radius: 50%
        padding: 3px
    .indexNum
      flex-basis: 80px
    .typeName
      flex: 1
      text-align: left
      word-break: break-word
    .operationBtn
      flex-basis: 170px
      text-align: left
el-dialog
    min-width: 750px
.noBorder ::v-deep .el-input__inner
  border: none !important
.noFocusEffect
    color: #666
    border-color: #ccc
    background-color: #FFFFFF
    &:hover
      color: $mainColor
      border-color: #c6e2d8
      background-color: #ecf5f2
.normalInput  ::v-deep .el-input__inner
  height: 30px !important
  font-size: 15px !important
.alignRight
  text-align: right !important
  margin-right: 10px
.el-input__inner
  font-size: 15px !important
.arrange
  float: right
  margin-top: 3px
  padding-left: 10px
.disabledGrey ::v-deep [disabled="disabled"]
  background-color:$bgDark3 !important
.cursorMove
  cursor: move
  .normalList,.typeName,.operationBtn,.noBorder, ::v-deep .el-input__inner,&.sortable-chosen,&.sortable-ghost
    cursor: move
.sortable-chosen, .sortable-ghost
  cursor: move !important
</style>
